import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Row,
  Badge,
  Input,
  UncontrolledTooltip,
} from "reactstrap";
import Select, { components } from "react-select";
import { useNavigate } from "react-router-dom";
import AdminHeader from "components/Headers/AdminHeader";
import {
  DEFAULT_RECORDS_PER_PAGE,
  PAYMENT_STATUS_OPTION,
} from "components/constant";
import CommonTable from "components/CommonComponents/ReactTable/Table";
import { fixedWidthCustomStyle } from "constants/CommonConstants";
import { ISOToHumanReadableDate } from "components/CommonComponents/CommonFunctions";
import { urlEncodedId } from "components/CommonComponents/encodeDecodeFunction";

//statid list
const invoiceList = [
  {
    id: 1,
    invoiceNumber: "INV-2024-001",
    orderId: "ORD-1001",
    paymentId: "PAY-9001",
    courseName: "Industrial Connectors Training",
    batchName: "Batch A - Pune",
    traineeName: "Amit Sharma",
    paymentAmount: 15000,
    gstAmount: 2700,
    totalAmount: 17700,
    paymentStatus: "Success",
    invoiceType: "GST",
    invoiceDate: "2024-01-15",
  },
  {
    id: 2,
    invoiceNumber: "INV-2024-002",
    orderId: "ORD-1002",
    paymentId: "PAY-9002",
    courseName: "PLC Automation Basics",
    batchName: null,
    traineeName: "Neha Verma",
    paymentAmount: 12000,
    gstAmount: 2160,
    totalAmount: 14160,
    paymentStatus: "Success",
    invoiceType: "GST",
    invoiceDate: "2024-01-18",
  },
  {
    id: 3,
    invoiceNumber: "INV-2024-003",
    orderId: "ORD-1003",
    paymentId: "PAY-9003",
    courseName: "Advanced Electrical Safety",
    batchName: "Batch B - Mumbai",
    traineeName: "Tech Skills Academy (Corporate)",
    paymentAmount: 50000,
    gstAmount: 9000,
    totalAmount: 59000,
    paymentStatus: "Success",
    invoiceType: "Corporate",
    invoiceDate: "2024-01-22",
  },
  {
    id: 4,
    invoiceNumber: "INV-2024-004",
    orderId: "ORD-1004",
    paymentId: "PAY-9004",
    courseName: "Panel Wiring Workshop",
    batchName: "Batch C - Delhi",
    traineeName: "Rahul Das",
    paymentAmount: 10000,
    gstAmount: 1800,
    totalAmount: 11800,
    paymentStatus: "Failed",
    invoiceType: "GST",
    invoiceDate: "2024-01-25",
  },
  {
    id: 5,
    invoiceNumber: "INV-2024-005",
    orderId: "ORD-1005",
    paymentId: "PAY-9005",
    courseName: "Industrial Automation Diploma",
    batchName: null,
    traineeName: "CodeNext Center (Corporate)",
    paymentAmount: 80000,
    gstAmount: 14400,
    totalAmount: 94400,
    paymentStatus: "Success",
    invoiceType: "Corporate",
    invoiceDate: "2024-01-28",
  },
  {
    id: 6,
    invoiceNumber: "INV-2024-006",
    orderId: "ORD-1006",
    paymentId: "PAY-9006",
    courseName: "SCADA Fundamentals",
    batchName: "Batch D - Bengaluru",
    traineeName: "Kavita Joshi",
    paymentAmount: 18000,
    gstAmount: 3240,
    totalAmount: 21240,
    paymentStatus: "Refunded",
    invoiceType: "GST",
    invoiceDate: "2024-02-02",
  },
  {
    id: 7,
    invoiceNumber: "INV-2024-007",
    orderId: "ORD-1007",
    paymentId: "PAY-9007",
    courseName: "VFD Drives Training",
    batchName: "Batch E - Chennai",
    traineeName: "Sneha Patil",
    paymentAmount: 14000,
    gstAmount: 2520,
    totalAmount: 16520,
    paymentStatus: "Success",
    invoiceType: "GST",
    invoiceDate: "2024-02-05",
  },
  {
    id: 8,
    invoiceNumber: "INV-2024-008",
    orderId: "ORD-1008",
    paymentId: "PAY-9008",
    courseName: "Corporate Safety Compliance",
    batchName: null,
    traineeName: "Digital Edge Academy (Corporate)",
    paymentAmount: 60000,
    gstAmount: 10800,
    totalAmount: 70800,
    paymentStatus: "Success",
    invoiceType: "Corporate",
    invoiceDate: "2024-02-08",
  },
];

function InvoicesListing() {
  const navigate = useNavigate();
  const [pageNum, setPageNum] = useState(1);

  const [searchState, setSearchState] = useState({
    query: "",
    paymentStatus: null,
    invoiceType: null,
    startDate: "",
    endDate: "",
    filterParams: [],
  });

  // Handle Download Invoice
  const handleDownloadInvoice = (invoice) => {
    const element = document.createElement("a");
    element.setAttribute("href", "/Sample Pdf.pdf");
    element.setAttribute("download", `${invoice.invoiceNumber}.pdf`);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  // Handle Open in New Tab
  const handleOpenInNewTab = (invoice) => {
    window.open("/Sample Pdf.pdf", "_blank");
  };

  //table columns

  const columns = [
    { Header: "Sr. No.", accessor: "id" },
    { Header: "Invoice No", accessor: "invoiceNumber" },
    { Header: "Order ID", accessor: "orderId" },
    { Header: "Payment ID", accessor: "paymentId" },
    { Header: "Course Name", accessor: "courseName" },
    {
      Header: "Batch Name",
      accessor: "batchName",
      Cell: ({ value }) => value || "-",
    },
    { Header: "Paid By", accessor: "traineeName" },
    {
      Header: "Paid Amount",
      accessor: "totalAmount",
      Cell: ({ value }) => `₹${value.toLocaleString()}`,
    },
    {
      Header: "Payment Status",
      accessor: "paymentStatus",
      Cell: ({ value }) => (
        <Badge
          color={
            value === "Success"
              ? "success"
              : value === "Failed"
                ? "danger"
                : "warning"
          }
          pill
        >
          {value}
        </Badge>
      ),
    },
    {
      Header: "Invoice Date",
      accessor: "invoiceDate",
      Cell: ({ value }) => ISOToHumanReadableDate(value),
    },
    {
      Header: "Actions",
      disableSortBy: true,
      Cell: ({ row }) => {
        const { id } = row.original;

        return (
          <div className="actions-right d-flex gap-2">
            <Button
              className="btn-link p-0"
              id={`details${id}`}
              size="sm"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenInNewTab(row.original);
                // setShowModal(true);
              }}
            >
              <i className="fa fa-eye mr-1" />
            </Button>
            <UncontrolledTooltip target={`details${id}`}>
              View Invoice
            </UncontrolledTooltip>

            {/* <span>|</span> */}

            <Button
              className="btn-link p-0 ml-2"
              id={`download${id}`}
              size="sm"
              onClick={(e) => {
                e.stopPropagation();
                handleDownloadInvoice(row.original);
              }}
            >
              <i className="fa fa-download mr-1" />
            </Button>
            <UncontrolledTooltip target={`download${id}`}>
              Download Invoice
            </UncontrolledTooltip>
          </div>
        );
      },
    },
  ];

  const hanldeOnRowClick = (rowData) => {
    const encodedId = urlEncodedId(rowData.id); //rowData.ID
    navigate(`/admin/invoices/${encodedId}/details`);
  };

  const clearSearch = () => {
    setSearchState({
      query: "",
      paymentStatus: null,
      invoiceType: null,
      startDate: "",
      endDate: "",
      filterParams: [],
    });
    if (pageNum !== 1) setPageNum(1);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const handleSearch = () => {};

  // Custom Option Renderer
  const Option = (props) => {
    return (
      <components.Option {...props}>
        <Badge
          color={
            props.data.value === "PAID"
              ? "success"
              : props.data.value === "FAILED"
                ? "danger"
                : "warning"
          }
          pill
        >
          {props.data.label}
        </Badge>
      </components.Option>
    );
  };

  // Custom SingleValue Renderer (for the selected value)
  const SingleValue = (props) => {
    return (
      <components.SingleValue {...props}>
        <Badge
          color={
            props.data.value === "PAID"
              ? "success"
              : props.data.value === "FAILED"
                ? "danger"
                : "warning"
          }
          pill
        >
          {props.data.label}
        </Badge>
      </components.SingleValue>
    );
  };

  return (
    <>
      <AdminHeader />
      <Container fluid className="mt--6">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader className="d-flex justify-content-between">
                <CardTitle tag="h3" className="mb-0">
                  Invoices
                </CardTitle>
              </CardHeader>

              <CardBody>
                {/* Filters */}
                <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap flex-column flex-md-row">
                  {/* Left side - Filter Inputs + Search */}
                  <div className="d-flex flex-wrap align-items-center filter-group">
                    <Input
                      placeholder="Search by invoice no"
                      className="mr-2 mb-2 filter-select"
                    />
                    <Input
                      placeholder="Search by order id"
                      className="mr-2 mb-2 filter-select"
                    />
                    <Input
                      placeholder="Search by payment id"
                      className="mr-2 mb-2 filter-select"
                    />
                    <Input
                      placeholder="Search by course, batch, paid by"
                      className="mr-2 mb-2 filter-input-large"
                    />

                    <Select
                      className="mr-2 mb-2 filter-select"
                      options={PAYMENT_STATUS_OPTION}
                      placeholder="Payment Status"
                      classNamePrefix="react-select"
                      styles={fixedWidthCustomStyle()}
                      components={{ Option, SingleValue }}
                      onKeyDown={handleKeyDown}
                    />

                    <div className="d-flex mr-2 mb-2 align-items-center date-range-wrapper">
                      <span className="mr-2">From</span>
                      <Input type="date" className="mr-1 mb-1 filter-select" />
                      <span className="mx-1">To</span>
                      <Input type="date" className="ml-1 mb-1 filter-select" />
                    </div>

                    <Button
                      color="default"
                      className="d-flex align-items-center mb-2 mt-0 filter-btn btn-deep-blue"
                    >
                      <i className="fa fa-search mr-1" />
                      Search
                    </Button>
                    {searchState.filterParams.length > 0 && (
                      <Button
                        color="default"
                        className="mb-3 filter-btn btn-simple"
                        onClick={clearSearch}
                      >
                        <i className="fa fa-times mr-1" /> Clear
                      </Button>
                    )}
                  </div>
                </div>

                <div className="mt-2 mb-3 mx-1">
                  {invoiceList.length ? (
                    <span className="total-records">
                      Total Records : {invoiceList.length}
                    </span>
                  ) : null}
                </div>

                <CommonTable
                  columns={columns}
                  data={invoiceList}
                  defaultPageSize={DEFAULT_RECORDS_PER_PAGE || 10}
                  activePage={pageNum}
                  setPageNum={setPageNum}
                  totalRecords={invoiceList.length}
                  showPaginationBottom
                  rowClick={(row) => hanldeOnRowClick(row)}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default InvoicesListing;
